function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Box, Button, Divider, Flex, HStack, Icon, Spinner, Stack, Text, useColorModeValue, useToken } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowTrendDown, faArrowTrendUp } from '@fortawesome/free-solid-svg-icons';
import { Glyph, Graph, GraphContainer } from '@/components/Graph';
import { AnimatedGrid, AnimatedAxis } from '@visx/xychart';
import Panel from '@/components/Panel';
import { FormattedMessage, useIntl } from 'react-intl';
import dayjs from 'dayjs';
function CustomTab(_param) {
    var total = _param.total, title = _param.title, dayDelta = _param.dayDelta, _param_inversePositive = _param.inversePositive, inversePositive = _param_inversePositive === void 0 ? false : _param_inversePositive, _param_negativeColor = _param.negativeColor, negativeColor = _param_negativeColor === void 0 ? 'negative' : _param_negativeColor, props = _object_without_properties(_param, [
        "total",
        "title",
        "dayDelta",
        "inversePositive",
        "negativeColor"
    ]);
    var positive = dayDelta > 0;
    if (inversePositive) {
        positive = !positive;
    }
    var icon = faArrowTrendUp;
    if (dayDelta < 0) {
        icon = faArrowTrendDown;
    } else if (dayDelta === 0) {
        icon = undefined;
    }
    var positiveColor = positive ? 'success' : negativeColor;
    if (dayDelta === 0) {
        positiveColor = 'intermediate';
    }
    return /*#__PURE__*/ _jsx(Button, _object_spread_props(_object_spread({
        height: "100%",
        variant: "ghost",
        borderRadius: "none",
        justifyContent: "left",
        textAlign: "left",
        paddingX: 6,
        paddingY: 4,
        borderColor: "borderTertiary",
        borderBottomWidth: 1
    }, props), {
        children: /*#__PURE__*/ _jsxs(Stack, {
            spacing: 0,
            children: [
                /*#__PURE__*/ _jsx(Text, {
                    fontSize: "sm",
                    color: "textPrimary",
                    children: title
                }),
                /*#__PURE__*/ _jsxs(HStack, {
                    spacing: 2,
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ _jsx(Text, {
                            fontSize: "4xl",
                            fontWeight: 900,
                            color: "textPrimary",
                            children: total.toLocaleString()
                        }),
                        /*#__PURE__*/ _jsxs(Stack, {
                            spacing: 0,
                            lineHeight: 1.2,
                            children: [
                                /*#__PURE__*/ _jsx(Text, {
                                    fontSize: "xs",
                                    color: "textSecondary",
                                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                        id: "zWgbGg",
                                        defaultMessage: "Today"
                                    })
                                }),
                                /*#__PURE__*/ _jsxs(Text, {
                                    fontSize: "sm",
                                    color: positiveColor,
                                    children: [
                                        icon != null ? /*#__PURE__*/ _jsx(Icon, {
                                            mr: 1,
                                            as: FontAwesomeIcon,
                                            icon: icon
                                        }) : null,
                                        Math.abs(Math.ceil(dayDelta)),
                                        "%"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }));
}
function calculateDelta(a, b) {
    if (b == null || a == null || a === 0 || b === 0) {
        return 0;
    }
    return (b - a) / a * 100;
}
function getLastTwoCounts(coordinates) {
    var _coordinates_slice_map = _sliced_to_array(coordinates.slice(-2).map(function(c) {
        return c.y;
    }), 2), a = _coordinates_slice_map[0], b = _coordinates_slice_map[1];
    return [
        a,
        b
    ];
}
var TabIndex;
(function(TabIndex) {
    TabIndex[TabIndex["MESSAGES"] = 0] = "MESSAGES";
    TabIndex[TabIndex["COMMANDS"] = 1] = "COMMANDS";
    TabIndex[TabIndex["TIMEOUTS"] = 2] = "TIMEOUTS";
})(TabIndex || (TabIndex = {}));
function createCoordinates(startDate, endDate, data) {
    var _loop = function(date) {
        var dateString = date.toISOString().split('T')[0];
        if (data == null) {
            coordinates.push({
                x: dateString,
                y: 0
            });
            return "continue";
        }
        var item = data.find(function(item) {
            return item.date === dateString;
        });
        var _item_count;
        coordinates.push({
            x: dateString,
            y: (_item_count = item === null || item === void 0 ? void 0 : item.count) !== null && _item_count !== void 0 ? _item_count : 0
        });
    };
    var start = new Date(startDate);
    var end = new Date(endDate);
    var coordinates = [];
    for(var date = start; date <= end; date = new Date(date.setDate(date.getDate() + 1)))_loop(date);
    return coordinates;
}
export default function StatGraphs(param) {
    var isLoading = param.isLoading, stats = param.stats;
    var intl = useIntl();
    var _React_useState = _sliced_to_array(React.useState(new Set([
        0,
        1,
        2
    ])), 2), tabs = _React_useState[0], setTabs = _React_useState[1];
    var ref = React.useRef(null);
    var _React_useState1 = _sliced_to_array(React.useState({
        width: 0,
        height: 0
    }), 2), _React_useState_ = _React_useState1[0], width = _React_useState_.width, height = _React_useState_.height, setDimensions = _React_useState1[1];
    var borderTertiary = useToken('colors', 'borderTertiary');
    var commandsStrokeColor = useColorModeValue('green.300', 'green.500');
    var messagesStrokeColor = useColorModeValue('primary.300', 'primary.500');
    var timeoutsStrokeColor = useColorModeValue('purple.300', 'purple.500');
    var commandsBackgroundColor = useColorModeValue('greenAlpha.300', 'greenAlpha.500');
    var messagesBackgroundColor = useColorModeValue('primaryAlpha.300', 'primaryAlpha.500');
    var timeoutsBackgroundColor = useColorModeValue('purpleAlpha.300', 'purpleAlpha.500');
    React.useLayoutEffect(function() {
        var updateDimensions = function updateDimensions() {
            if (ref.current == null) {
                return;
            }
            var _ref_current_getBoundingClientRect = ref.current.getBoundingClientRect(), width = _ref_current_getBoundingClientRect.width, height = _ref_current_getBoundingClientRect.height;
            setDimensions({
                width: width,
                height: height
            });
        };
        updateDimensions();
        window.addEventListener('resize', updateDimensions);
        return function() {
            window.removeEventListener('resize', updateDimensions);
        };
    }, [
        ref,
        stats
    ]);
    var _React_useMemo = _sliced_to_array(React.useMemo(function() {
        if (stats == null) {
            return [
                [],
                [],
                []
            ];
        }
        return [
            createCoordinates(stats.start, stats.end, stats.messages.messages),
            createCoordinates(stats.start, stats.end, stats.commands.commands),
            createCoordinates(stats.start, stats.end, stats.timeouts.timeouts)
        ];
    }, [
        stats
    ]), 3), messageData = _React_useMemo[0], commandData = _React_useMemo[1], timeoutData = _React_useMemo[2];
    var toggleTab = React.useCallback(function(index) {
        if (tabs.has(index)) {
            tabs.delete(index);
        } else {
            tabs.add(index);
        }
        setTabs(new Set(tabs));
    }, [
        tabs
    ]);
    if (stats == null || isLoading) {
        return /*#__PURE__*/ _jsx(Panel, {
            height: "400px",
            display: "grid",
            placeItems: "center",
            children: /*#__PURE__*/ _jsx(Spinner, {})
        });
    }
    return /*#__PURE__*/ _jsxs(Panel, {
        padding: 0,
        height: {
            base: 'fit-content',
            md: '400px'
        },
        display: "flex",
        flexDirection: "column",
        children: [
            /*#__PURE__*/ _jsxs(Flex, {
                flexDirection: {
                    base: 'column',
                    md: 'row'
                },
                children: [
                    /*#__PURE__*/ _jsx(CustomTab, {
                        flex: 1,
                        onClick: function() {
                            return toggleTab(0);
                        },
                        total: stats.messages.count,
                        title: intl.formatMessage({
                            id: "hMzcSq",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Messages"
                                }
                            ]
                        }),
                        dayDelta: calculateDelta.apply(void 0, _to_consumable_array(getLastTwoCounts(messageData))),
                        opacity: tabs.has(0) ? 1 : 0.5
                    }),
                    /*#__PURE__*/ _jsx(Divider, {
                        orientation: "vertical",
                        borderColor: "borderSecondary"
                    }),
                    /*#__PURE__*/ _jsx(CustomTab, {
                        flex: 1,
                        onClick: function() {
                            return toggleTab(1);
                        },
                        total: stats.commands.count,
                        title: intl.formatMessage({
                            id: "TY8Ho1",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Commands"
                                }
                            ]
                        }),
                        dayDelta: calculateDelta.apply(void 0, _to_consumable_array(getLastTwoCounts(commandData))),
                        opacity: tabs.has(1) ? 1 : 0.5
                    }),
                    /*#__PURE__*/ _jsx(Divider, {
                        orientation: "vertical",
                        borderColor: "borderSecondary"
                    }),
                    /*#__PURE__*/ _jsx(CustomTab, {
                        flex: 1,
                        onClick: function() {
                            return toggleTab(2);
                        },
                        total: stats.timeouts.count,
                        title: intl.formatMessage({
                            id: "WW4fHR",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Timeouts"
                                }
                            ]
                        }),
                        inversePositive: true,
                        negativeColor: "intermediate",
                        dayDelta: calculateDelta.apply(void 0, _to_consumable_array(getLastTwoCounts(timeoutData))),
                        opacity: tabs.has(2) ? 1 : 0.5
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Box, {
                flex: 1,
                height: "100%",
                ref: ref,
                display: {
                    base: 'none',
                    md: 'block'
                },
                children: /*#__PURE__*/ _jsxs(GraphContainer, {
                    width: width,
                    height: height,
                    data: createCoordinates(stats.start, stats.end),
                    renderTooltip: function(datum) {
                        var _messageData_find, _commandData_find, _timeoutData_find;
                        var _messageData_find_y;
                        var messageValue = (_messageData_find_y = (_messageData_find = messageData.find(function(item) {
                            return item.x === datum.x;
                        })) === null || _messageData_find === void 0 ? void 0 : _messageData_find.y) !== null && _messageData_find_y !== void 0 ? _messageData_find_y : 0;
                        var _commandData_find_y;
                        var commandValue = (_commandData_find_y = (_commandData_find = commandData.find(function(item) {
                            return item.x === datum.x;
                        })) === null || _commandData_find === void 0 ? void 0 : _commandData_find.y) !== null && _commandData_find_y !== void 0 ? _commandData_find_y : 0;
                        var _timeoutData_find_y;
                        var timeoutValue = (_timeoutData_find_y = (_timeoutData_find = timeoutData.find(function(item) {
                            return item.x === datum.x;
                        })) === null || _timeoutData_find === void 0 ? void 0 : _timeoutData_find.y) !== null && _timeoutData_find_y !== void 0 ? _timeoutData_find_y : 0;
                        return /*#__PURE__*/ _jsxs(Panel, {
                            gap: 0,
                            padding: 0,
                            as: Stack,
                            minWidth: "160px",
                            children: [
                                /*#__PURE__*/ _jsx(Text, {
                                    padding: 2,
                                    fontSize: "sm",
                                    color: "textPrimary",
                                    children: dayjs(datum.x).format('dddd, Do')
                                }),
                                /*#__PURE__*/ _jsx(Divider, {
                                    borderColor: "borderTertiary"
                                }),
                                /*#__PURE__*/ _jsxs(Stack, {
                                    padding: 2,
                                    spacing: 2,
                                    children: [
                                        tabs.has(0) ? /*#__PURE__*/ _jsxs(HStack, {
                                            spacing: 2,
                                            children: [
                                                /*#__PURE__*/ _jsx(Glyph, {
                                                    translate: false,
                                                    size: 4,
                                                    strokeColor: "primary.500",
                                                    backgroundColor: "primaryAlpha.500"
                                                }),
                                                /*#__PURE__*/ _jsx(Text, {
                                                    fontSize: "sm",
                                                    color: "textSecondary",
                                                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                                        id: "uQpqQT",
                                                        defaultMessage: "{amount, plural, =1 {1 message} other {# messages}}",
                                                        values: {
                                                            amount: messageValue
                                                        }
                                                    })
                                                })
                                            ]
                                        }) : null,
                                        tabs.has(1) ? /*#__PURE__*/ _jsxs(HStack, {
                                            spacing: 2,
                                            children: [
                                                /*#__PURE__*/ _jsx(Glyph, {
                                                    translate: false,
                                                    size: 4,
                                                    strokeColor: "green.500",
                                                    backgroundColor: "greenAlpha.500"
                                                }),
                                                /*#__PURE__*/ _jsx(Text, {
                                                    fontSize: "sm",
                                                    color: "textSecondary",
                                                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                                        id: "+oM4JW",
                                                        defaultMessage: "{amount, plural, =1 {1 command} other {# commands}}",
                                                        values: {
                                                            amount: commandValue
                                                        }
                                                    })
                                                })
                                            ]
                                        }) : null,
                                        tabs.has(2) ? /*#__PURE__*/ _jsxs(HStack, {
                                            spacing: 2,
                                            children: [
                                                /*#__PURE__*/ _jsx(Glyph, {
                                                    translate: false,
                                                    size: 4,
                                                    strokeColor: "purple.500",
                                                    backgroundColor: "purpleAlpha.500"
                                                }),
                                                /*#__PURE__*/ _jsx(Text, {
                                                    fontSize: "sm",
                                                    color: "textSecondary",
                                                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                                        id: "URy38l",
                                                        defaultMessage: "{amount, plural, =1 {1 timeout} other {# timeouts}}",
                                                        values: {
                                                            amount: timeoutValue
                                                        }
                                                    })
                                                })
                                            ]
                                        }) : null
                                    ]
                                })
                            ]
                        });
                    },
                    children: [
                        /*#__PURE__*/ _jsx(AnimatedAxis, {
                            hideTicks: true,
                            strokeWidth: 0,
                            orientation: "left",
                            numTicks: 4
                        }),
                        tabs.has(0) ? /*#__PURE__*/ _jsx(Graph, {
                            dataKey: "messages",
                            data: messageData,
                            strokeColor: messagesStrokeColor,
                            fromGradientColor: messagesBackgroundColor,
                            toGradientColor: "primaryAlpha.50"
                        }) : null,
                        tabs.has(1) ? /*#__PURE__*/ _jsx(Graph, {
                            dataKey: "commands",
                            data: commandData,
                            strokeColor: commandsStrokeColor,
                            fromGradientColor: commandsBackgroundColor,
                            toGradientColor: "greenAlpha.50"
                        }) : null,
                        tabs.has(2) ? /*#__PURE__*/ _jsx(Graph, {
                            dataKey: "timeouts",
                            data: timeoutData,
                            strokeColor: timeoutsStrokeColor,
                            fromGradientColor: timeoutsBackgroundColor,
                            toGradientColor: "purpleAlpha.50"
                        }) : null,
                        /*#__PURE__*/ _jsx(AnimatedGrid, {
                            numTicks: 7,
                            lineStyle: {
                                stroke: borderTertiary
                            }
                        })
                    ]
                })
            })
        ]
    });
}
